import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import './PlumbingSection.scss';

interface PlumbingModalProps {
    isVisible: boolean;
    onCancel: () => void;
}

export const PlumbingModal = ({ isVisible, onCancel }: PlumbingModalProps): JSX.Element => {
    const { t } = useTranslation();
    const content: string[] = t('SCROLLABLE_AREA.PLUMBING.MODAL.CONTENT', { returnObjects: true });

    return (
        <Modal
            centered
            destroyOnClose
            open={isVisible}
            closable
            footer={null}
            width="40%"
            className="PlumbingModal"
            onCancel={onCancel}
            title={<div className="PlumbingModal__title">{t('SCROLLABLE_AREA.PLUMBING.MODAL.TITLE')}</div>}
            keyboard
        >
            <div className="PlumbingModal__content">
                {content.map((item, index) => (
                    <p key={index}>{item}</p>
                ))}
            </div>
        </Modal>
    );
};
